<app-data-set #dataSet [dataSource]="dataSource" firstColumnProperty="device.serialNumber" [rowId]="rowId">
	<app-data-set-toolbar>
		<div *appSearchActionGroup style="flex: 1">
			<app-data-set-search
				defaultFilterName="serialNumber"
				[defaultFilterLabel]="filterLabels.serialNumber"
				[placeholder]="filterLabels.defaultPlaceholder"
			>
				@if (companyTypeFlag) {
					<div class="filter-grid" [style.--columns]="3">
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.serialNumber }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('serialNumber')"
									(ngModelChange)="dataSet.filter('serialNumber', filterLabels.serialNumber, $event)"
									data-automation-id="serial-number-input"
								/>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.deviceOwner }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('deviceOwner')"
									(ngModelChange)="dataSet.filter('deviceOwner', filterLabels.deviceOwner, $event)"
									data-automation-id="device-owner-input"
								/>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.clientName }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('clientName')"
									(ngModelChange)="dataSet.filter('clientName', filterLabels.clientName, $event)"
									data-automation-id="client-name-input-user"
								/>
							</mat-form-field>
						</div>
					</div>

					<div class="filter-grid" [style.--columns]="3">
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.clientIDN }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('clientIDN')"
									(ngModelChange)="dataSet.filter('clientIDN', filterLabels.clientIDN, $event)"
									data-automation-id="client-idn-input-user"
								/>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.propertyName }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('locationName')"
									(ngModelChange)="dataSet.filter('locationName', filterLabels.propertyName, $event)"
									data-automation-id="property-name-input"
								/>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.deviceLocation }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('deviceLocation')"
									(ngModelChange)="dataSet.filter('deviceLocation', filterLabels.deviceLocation, $event)"
									data-automation-id="device-location-input"
								/>
							</mat-form-field>
						</div>
					</div>

					<div class="filter-grid" [style.--columns]="4">
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.eventType }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('eventType')"
									(ngModelChange)="dataSet.filter('eventType', filterLabels.eventType, $event)"
									data-automation-id="event-type-input"
								/>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.eventStart }}</mat-label>
								<input
									matInput
									[matDatepicker]="careEventStartPicker"
									[ngModel]="dataSet.filter('eventStart')"
									(ngModelChange)="dataSet.filter('eventStart', filterLabels.eventStart, $event)"
									data-automation-id="event-start-input"
								/>
								<mat-datepicker-toggle
									matSuffix
									class="date-picker-primary-blue"
									[for]="careEventStartPicker"
									data-automation-id="event-start-toggle"
								></mat-datepicker-toggle>
								<mat-datepicker #careEventStartPicker data-automation-id="event-start-datepicker"></mat-datepicker>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.eventEnd }}</mat-label>
								<input
									matInput
									[matDatepicker]="careEventEndPicker"
									[ngModel]="dataSet.filter('eventEnd')"
									(ngModelChange)="dataSet.filter('eventEnd', filterLabels.eventEnd, $event)"
									data-automation-id="event-end-input"
								/>
								<mat-datepicker-toggle
									matSuffix
									class="date-picker-primary-blue"
									[for]="careEventEndPicker"
									data-automation-id="event-end-toggle"
								></mat-datepicker-toggle>
								<mat-datepicker #careEventEndPicker data-automation-id="event-end-datepicker"></mat-datepicker>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.endVisitType }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('endVisitType')"
									(ngModelChange)="dataSet.filter('endVisitType', filterLabels.endVisitType, $event)"
									data-automation-id="end-visit-type-input"
								/>
							</mat-form-field>
						</div>
					</div>
				} @else {
					<div class="filter-grid" [style.--columns]="4">
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.serialNumber }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('serialNumber')"
									(ngModelChange)="dataSet.filter('serialNumber', filterLabels.serialNumber, $event)"
									data-automation-id="serial-number-input"
								/>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.deviceOwner }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('deviceOwner')"
									(ngModelChange)="dataSet.filter('deviceOwner', filterLabels.deviceOwner, $event)"
									data-automation-id="device-owner-input"
								/>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.propertyName }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('locationName')"
									(ngModelChange)="dataSet.filter('locationName', filterLabels.propertyName, $event)"
									data-automation-id="property-name-input"
								/>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.deviceLocation }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('deviceLocation')"
									(ngModelChange)="dataSet.filter('deviceLocation', filterLabels.deviceLocation, $event)"
									data-automation-id="device-location-input"
								/>
							</mat-form-field>
						</div>
					</div>

					<div class="filter-grid" [style.--columns]="4">
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.eventType }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('eventType')"
									(ngModelChange)="dataSet.filter('eventType', filterLabels.eventType, $event)"
									data-automation-id="event-type-input"
								/>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.eventStart }}</mat-label>
								<input
									matInput
									[matDatepicker]="eventStartPicker"
									[ngModel]="dataSet.filter('eventStart')"
									(ngModelChange)="dataSet.filter('eventStart', filterLabels.eventStart, $event)"
									data-automation-id="event-start-input"
								/>
								<mat-datepicker-toggle
									matSuffix
									class="date-picker-primary-blue"
									[for]="eventStartPicker"
									data-automation-id="event-start-toggle"
								></mat-datepicker-toggle>
								<mat-datepicker #eventStartPicker data-automation-id="event-start-datepicker"></mat-datepicker>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.eventEnd }}</mat-label>
								<input
									matInput
									[matDatepicker]="eventEndPicker"
									[ngModel]="dataSet.filter('eventEnd')"
									(ngModelChange)="dataSet.filter('eventEnd', filterLabels.eventEnd, $event)"
									data-automation-id="event-end-input"
								/>
								<mat-datepicker-toggle
									matSuffix
									class="date-picker-primary-blue"
									[for]="eventEndPicker"
									data-automation-id="event-end-toggle"
								></mat-datepicker-toggle>
								<mat-datepicker #eventEndPicker data-automation-id="event-end-datepicker"></mat-datepicker>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.endVisitType }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('endVisitType')"
									(ngModelChange)="dataSet.filter('endVisitType', filterLabels.endVisitType, $event)"
									data-automation-id="end-visit-type-input"
								/>
							</mat-form-field>
						</div>
					</div>
				}
			</app-data-set-search>
		</div>

		@if (this.canGenerateEventHistoryReport) {
			<div *appActionGroup>
				<app-data-set-action-button
					label="Download"
					i18n-label="@@userEvenHistory-download"
					(click)="this.isDownloadReportDisabled ? null : generateEventHistoryReport()"
					[isDisabled]="this.isDownloadReportDisabled"
					data-automation-id="user-event-history-download-button"
				></app-data-set-action-button>
			</div>
		}
	</app-data-set-toolbar>

	<app-data-set-content>
		<app-data-set-table-view>
			@if (
				loadingService.isLoading(getUserEventHistoryLoadingKey) ||
				loadingService.isLoading(getEventHistoryReportLoadingKey) ||
				!finishedLoadingInitData
			) {
				<app-data-set-loading-row />
			}
			<table
				mat-table
				[dataSource]="dataSource"
				matSortActive="eventStart"
				matSortDirection="desc"
				matSort
				[hidden]="
					loadingService.isLoading(getUserEventHistoryLoadingKey) ||
					loadingService.isLoading(getEventHistoryReportLoadingKey) ||
					!finishedLoadingInitData
				"
			>
				<tr class="mat-row" *matNoDataRow>
					<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
						No records found.
					</td>
				</tr>

				<ng-container matColumnDef="serialNumber">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@userEventHistory-serialNumber">
						Serial Number
					</th>
					<td mat-cell *matCellDef="let row">{{ valueOrDashes(row.device?.serialNumber) }}</td>
				</ng-container>

				<ng-container matColumnDef="deviceOwner">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@userEventHistory-deviceOwner">Device Owner</th>
					<td mat-cell *matCellDef="let row">{{ valueOrDashes(row.device?.activeDeviceAssignment?.company?.name) }}</td>
				</ng-container>

				@if (companyTypeFlag) {
					<ng-container matColumnDef="clientName">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@userEventHistory-clientName">Client Name</th>
						<td mat-cell *matCellDef="let row">{{ valueOrDashes(row.clientInformation?.clientName) }}</td>
					</ng-container>
					<ng-container matColumnDef="clientIDN">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@userEventHistory-clientIDN">Client IDN</th>
						<td mat-cell *matCellDef="let row">{{ valueOrDashes(row.clientInformation?.clientIDN) }}</td>
					</ng-container>
				}

				<ng-container matColumnDef="locationName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@userEventHistory-propertyName">
						Property Name
					</th>
					<td mat-cell *matCellDef="let row">{{ valueOrDashes(row.location?.name) }}</td>
				</ng-container>

				<ng-container matColumnDef="deviceLocation">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@propertyEventHistory-deviceLocation">
						Device Location
					</th>
					<td mat-cell *matCellDef="let row">{{ valueOrDashes(row.installationLocation?.name) }}</td>
				</ng-container>

				<ng-container matColumnDef="eventType">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@userEventHistory-eventType">Event Type</th>
					<td mat-cell *matCellDef="let row">
						{{ valueOrDashes(row.eventName | eventTypeFormat: row.deviceRemovalAccessOptionsEnabled : row.metadata) }}
					</td>
				</ng-container>

				<ng-container matColumnDef="eventStart">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@userEventHistory-eventStart">Event Start</th>
					<td mat-cell *matCellDef="let row">
						@if (row.location) {
							<div class="date-time-container">
								@if (row.utcStartDate) {
									<span>
										{{
											row.utcStartDate
												| date
													: 'mediumDate'
													: timeZoneService.utcOffset(row.utcStartDate, row.location?.timezone ?? 'UTC')
										}}
										<br />
										{{
											(row.utcStartDate
												| date
													: 'shortTime'
													: timeZoneService.utcOffset(row.utcStartDate, row.location?.timezone ?? 'UTC')) +
												' ' +
												(row.location?.timezone ?? 'UTC' | abbreviatedTimezone: row.utcStartDate)
										}}
									</span>
								}
								@if (!row.utcStartDate) {
									<span>- - -</span>
								}
								@if (row.alarmStart === AlarmStatus.disarm) {
									<img
										src="assets/icons/icon-shield-with-x.svg"
										class="ajax-icon"
										[alt]="disarmedAlarmText"
										[title]="disarmedAlarmText"
									/>
								}
								@if (row.alarmStart === AlarmStatus.overriden) {
									<img
										src="assets/icons/icon-bell-crossed-out-orange.svg"
										class="ajax-icon bell-icon"
										[alt]="alarmOverrideText"
										[title]="alarmOverrideText"
									/>
								}
							</div>
						}
						@if (!row.location) {
							<div>
								<div>{{ valueOrDashes(row.utcStartDate | billingStartDateFilter) }}</div>
								<div>{{ valueOrDashes(row.utcStartDate | requestTimeToLocal) }}</div>
							</div>
						}
					</td>
				</ng-container>

				<ng-container matColumnDef="eventEnd">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@userEventHistory-eventEnd">Event End</th>
					<td mat-cell *matCellDef="let row">
						@if (row.location) {
							<div class="date-time-container">
								@if (row.utcEndDate) {
									<span>
										{{
											row.utcEndDate
												| date
													: 'mediumDate'
													: timeZoneService.utcOffset(row.utcEndDate, row.location?.timezone ?? 'UTC')
										}}
										<br />
										{{
											(row.utcEndDate
												| date
													: 'shortTime'
													: timeZoneService.utcOffset(row.utcEndDate, row.location?.timezone ?? 'UTC')) +
												' ' +
												(row.location?.timezone ?? 'UTC' | abbreviatedTimezone: row.utcEndDate)
										}}
									</span>
								}
								@if (!row.utcEndDate) {
									<span>- - -</span>
								}
								@if (row.alarmEnd === AlarmStatus.arm) {
									<img
										src="assets/icons/icon-shield-checkmark-red.svg"
										class="ajax-icon"
										[alt]="armedAlarmText"
										[title]="armedAlarmText"
									/>
								}
							</div>
						}
						@if (!row.location) {
							<div>- - -</div>
						}
					</td>
				</ng-container>

				<ng-container matColumnDef="endVisitType">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@userEventHistory-endVisitType">
						End Visit Type
					</th>
					<td mat-cell *matCellDef="let row">{{ valueOrDashes(row.endVisitType | endVisitTypeFormat) }}</td>
				</ng-container>

				<ng-container matColumnDef="dwellTime">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@userEventHistory-accessDuration">Dwell Time</th>
					<td mat-cell *matCellDef="let row">{{ valueOrDashes(row.eventDuration | eventDuration) }}</td>
				</ng-container>

				<ng-container matColumnDef="rowMenu">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let row"></td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
			</table>
		</app-data-set-table-view>
	</app-data-set-content>
</app-data-set>
